import * as React from 'react';
import { useCognitoContext } from '../../providers/cognito.provider';
import type { SignupFormValues } from '@components/organisms/signup-form/useSignupForm';
import type { ResponseResult } from '@utils';
import { setTokens } from '../../../utils/network/utils';

export enum SignupStepEnum {
	SIGNUP = 'signup',
	CONFIRM = 'confirm',
}

type Props = {
	onSuccess: (data: any) => void;
};

export const useSignup = ({ onSuccess }: Props) => {
	const { credentialsSignup, confirmSignup, resendConfirmationCode } = useCognitoContext();
	const [step, setStep] = React.useState<SignupStepEnum>(SignupStepEnum.SIGNUP);
	const [signupData, setSignupData] = React.useState<SignupFormValues | null>(null);

	const handleSignup = React.useCallback(
		async (data: SignupFormValues): Promise<ResponseResult<any>> => {
			const { email, password, firstName, lastName } = data;

			const response = await credentialsSignup(email, password, firstName, lastName);

			if (response.error) {
				return response;
			}

			setTokens(response.result.credentials);

			onSuccess(response.result);

			//setSignupData(data);
			//setStep('confirm');
			return response;
		},
		[credentialsSignup]
	);

	const handleConfirm = React.useCallback(
		async (data): Promise<ResponseResult<any>> => {
			const response = await confirmSignup(signupData!.email, signupData!.password, data.code);

			if (response.result) {
				onSuccess(response);
			}

			return response;
		},
		[confirmSignup, onSuccess, signupData]
	);

	const handleResendCode = React.useCallback((): void => {
		resendConfirmationCode(signupData!.email).catch(error => console.error(error));
	}, [resendConfirmationCode, signupData]);

	return {
		step,
		handleSignup,
		handleConfirm,
		handleResendCode,
	};
};
